export interface ActionPayload {
    payload: any;
    type: string;
    meta?: string;
}

// export interface LastRespState {
//     lastResponseTime: Date;
// }

// export const initialLastRespState:LastRespState = {
//     lastResponseTime: new Date()
// }
export interface ChatCommonState {
    welcomeMsg: WelcomeMsg;
    lastResponseTime: Date;
}

export const ChatCommonStateInit = {
    welcomeMsg: {
        messageOne: "",
        messageTwo: "",
        securityAlert: "",
        typingMessage: "",
        scheduleSecurityAlert: null,
        securityAlertStartTime: null,
        securityAlertEndTime: null
    },
    lastResponseTime: new Date()
}

export interface WelcomeMsg {
    messageOne: string;
    messageTwo: string;
    securityAlert: string;
    typingMessage: string;
    scheduleSecurityAlert: boolean;
    securityAlertStartTime: number;
    securityAlertEndTime: number;
    buddyTextConfiguration?: BuddyTextConfiguration;
}

export interface BuddyTextConfiguration {
    inferEncoding?: boolean;
}